module.exports = __webpack_public_path__ + "h5/img/banner_1.30f9c69c.jpg";